/* src/app/reporting/presenters/reporting.component.scss */
.p-card {
  height: 100% !important;
}
.treetable-panel .p-panel-header {
  padding: 0 !important;
}
.p-drawer-header {
  padding: 0.75rem !important;
  padding-left: 1.25rem !important;
  padding-bottom: 0 !important;
}
.p-drawer-content {
  overflow-y: hidden !important;
}
.p-drawer.p-drawer-right .p-drawer-header {
  padding: 0.75rem !important;
  padding-left: 1.25rem !important;
  padding-bottom: 0 !important;
}
.p-drawer.p-drawer-right .p-drawer-content {
  overflow-y: hidden !important;
}
.p-drawer-mask .p-drawer.p-drawer-right .p-drawer-header {
  padding: 0.75rem !important;
  padding-left: 1.25rem !important;
  padding-bottom: 0 !important;
}
.p-drawer-mask .p-drawer.p-drawer-right .p-drawer-content {
  overflow-y: hidden !important;
}
/*# sourceMappingURL=reporting.component.css.map */
